var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormProvider, useForm } from 'react-hook-form';
import { usersApi } from 'apis/users';
import { analytics } from 'app/utils/segment';
import { NOTIFICATION_DEFAULT, OFFER_NOTIFICATION_INCOMING, } from 'components/notifications/sagas/audio';
import { actions as personalActions } from 'components/settings/actions/personal';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useCurrentUser } from 'utils/user';
import { profileActions } from '../../settingsProfile.actions';
import { ProfileFormInfo } from './components/info/profileFormInfo';
import { ProfileFormSettings } from './components/settings/profileFormSettings';
import { ProfileFormSounds } from './components/sounds/profileFormSounds';
export const SettingsProfileForm = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const { user } = useCurrentUser();
    const soundsState = useAppSelector((state) => state.settings.personal.sounds);
    const form = useForm({
        mode: 'all',
        defaultValues: {
            given_name: (_a = user.given_name) !== null && _a !== void 0 ? _a : '',
            family_name: (_b = user.family_name) !== null && _b !== void 0 ? _b : '',
            name: (_c = user.name) !== null && _c !== void 0 ? _c : '',
            email: (_d = user.email) !== null && _d !== void 0 ? _d : '',
            phone_number: (_e = user.phone_number) !== null && _e !== void 0 ? _e : '',
            offer_notification_phone: [
                (_g = (_f = soundsState === null || soundsState === void 0 ? void 0 : soundsState.pstnphone) === null || _f === void 0 ? void 0 : _f.tone) !== null && _g !== void 0 ? _g : OFFER_NOTIFICATION_INCOMING,
            ],
            offer_notification_chat: [
                (_j = (_h = soundsState === null || soundsState === void 0 ? void 0 : soundsState.widgetchat) === null || _h === void 0 ? void 0 : _h.tone) !== null && _j !== void 0 ? _j : OFFER_NOTIFICATION_INCOMING,
            ],
            offer_notification_email: [
                (_l = (_k = soundsState === null || soundsState === void 0 ? void 0 : soundsState.email) === null || _k === void 0 ? void 0 : _k.tone) !== null && _l !== void 0 ? _l : OFFER_NOTIFICATION_INCOMING,
            ],
            offer_notification_messaging: [
                (_o = (_m = soundsState === null || soundsState === void 0 ? void 0 : soundsState.messaging) === null || _m === void 0 ? void 0 : _m.tone) !== null && _o !== void 0 ? _o : OFFER_NOTIFICATION_INCOMING,
            ],
            notification_sound: [
                (_q = (_p = soundsState === null || soundsState === void 0 ? void 0 : soundsState.notification) === null || _p === void 0 ? void 0 : _p.tone) !== null && _q !== void 0 ? _q : NOTIFICATION_DEFAULT,
            ],
        },
    });
    const [updateUser] = usersApi.useUpdateUserMutation();
    const handleValidSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        var _r, _s;
        try {
            const { data } = yield updateUser({
                id: user.id,
                patch: {
                    updates: Object.assign(Object.assign({ display_name: values.name, given_name: values.given_name, family_name: values.family_name }, (values.phone_number && { phone_number: values.phone_number })), (((_r = values.default_outbound_number) === null || _r === void 0 ? void 0 : _r.length) && {
                        default_outbound_number: values.default_outbound_number[0].e164_format,
                    })),
                    deletes: [
                        ...(values.phone_number ? [] : ['phone_number']),
                        ...(((_s = values.default_outbound_number) === null || _s === void 0 ? void 0 : _s.length)
                            ? []
                            : ['default_outbound_number']),
                    ],
                },
            }).unwrap();
            dispatch(profileActions.update({ user: data }));
            dispatch(personalActions.personalSound({
                key: 'sounds',
                value: {
                    pstnphone: {
                        tone: values.offer_notification_phone[0],
                    },
                    widgetchat: {
                        tone: values.offer_notification_chat[0],
                    },
                    email: {
                        tone: values.offer_notification_email[0],
                    },
                    messaging: {
                        tone: values.offer_notification_messaging[0],
                    },
                    notification: {
                        tone: values.notification_sound[0],
                    },
                },
            }));
            analytics.settingsProfileFormSubmitted({
                payload: {},
            });
            notify({
                title: 'Success',
                text: `Your profile has been updated.`,
                icon: 'done',
                time: 5000,
            }, NotificationType.Success);
        }
        catch (error) {
            notify({
                title: 'Error while saving your profile.',
            }, NotificationType.Error);
        }
    });
    return (_jsx(FormProvider, Object.assign({}, form, { children: _jsxs("form", Object.assign({ id: settingsProfileFormId, noValidate: true, tabIndex: -1, onSubmit: form.handleSubmit(handleValidSubmit) }, { children: [_jsx(ProfileFormInfo, {}), _jsx(ProfileFormSounds, {}), _jsx(ProfileFormSettings, {})] })) })));
};
export const settingsProfileFormId = 'profile';
